import AxiosControl from '../../context/axios/AxiosControl'
const Axios = AxiosControl()

const normalizeUploadUrl = (base, path) => {
    if (!base) return null
    return `${String(base).replace(/\/+$/, '')}${path}`
}

const uploadMatchImage = async (file, fieldLabel) => {
    if (!file || typeof file === 'string') return file

    const formData = new FormData()
    formData.append('image', file)

    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            auth: sessionStorage.getItem('jwt')
        }
    }

    const envBase = process.env.REACT_APP_DB_ADDRESS
    const candidates = [
        '/api/upload/uploadimage',
        '/upload/uploadimage',
        normalizeUploadUrl(envBase, '/api/upload/uploadimage'),
        normalizeUploadUrl(envBase, '/upload/uploadimage')
    ].filter(Boolean)

    let lastError = null
    for (const endpoint of [...new Set(candidates)]) {
        try {
            console.info('[MATCH_UPLOAD] Intento', { fieldLabel, endpoint, fileName: file?.name, fileType: file?.type, fileSize: file?.size })
            const { data } = await Axios.post(endpoint, formData, config)
            console.info('[MATCH_UPLOAD] OK', { fieldLabel, endpoint })
            return typeof data === 'string' ? data : data?.url || data?.location || data
        } catch (error) {
            lastError = error
            console.warn('[MATCH_UPLOAD] Error en intento', {
                fieldLabel,
                endpoint,
                status: error?.response?.status,
                response: error?.response?.data
            })
        }
    }

    console.error('[MATCH_UPLOAD] Fallo definitivo', {
        fieldLabel,
        lastStatus: lastError?.response?.status,
        lastResponse: lastError?.response?.data,
        envBase
    })
    const backendMessage = lastError?.response?.data
    throw new Error(`No se pudo subir ${fieldLabel}. ${backendMessage || ''}`.trim())
}

export const getMatchesByClub = (club) => async (dispatch) => {
    dispatch({
        type: 'MATCH_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/match/getMatchesByClub/'+ club, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'MATCH_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'MATCH_NOT_LOADING'
        })
    }
}

export const getAvailableMatchesByClub = (club) => async (dispatch) => {
    dispatch({
        type: 'MATCH_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/match/getAvailableMatchesByClub/'+ club, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'MATCH_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'MATCH_NOT_LOADING'
        })
    }
}

export const getPublicMatchesByClub = (club) => async (dispatch) => {
    dispatch({
        type: 'MATCH_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/match/public/getPublicMatchesByClub/'+ club, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'MATCH_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'MATCH_NOT_LOADING'
        })
    }
}

export const getMatch = (matchId) => async (dispatch) => {
    dispatch({
        type: 'MATCH_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/match/getMatch/'+ matchId, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'MATCH_GET_SUCCESS',
                payload: data?.match
            })
        }
    } catch (error) {
        dispatch({
            type: 'MATCH_NOT_LOADING'
        })
    }
}

export const getMatchPublicByUrl = ({url, club}) => async (dispatch) => {
    dispatch({
        type: 'MATCH_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/match/public/getPublicMatchByUrl/'+ url +'/'+ club)
        if (status === 200) {
            dispatch({
                type: 'MATCH_GET_SUCCESS',
                payload: data?.matchMarket
            })
        }
    } catch (error) {
        dispatch({
            type: 'MATCH_NOT_LOADING'
        })
    }
}

export const addMatch = (matchData) => async (dispatch) => {
    dispatch({
        type: 'MATCH_LOADING'
    })
    try {
        // Subida de escudo del anfitrión
        if (matchData.hostBadge) {
            matchData.hostBadge = await uploadMatchImage(matchData.hostBadge, 'el escudo local')
        }

        // Subida de escudo del visitante
        if (matchData.visitorBadge) {
            matchData.visitorBadge = await uploadMatchImage(matchData.visitorBadge, 'el escudo visitante')
        }

        // Subida de la miniatura
        if (matchData.thumbnail) {
            matchData.thumbnail = await uploadMatchImage(matchData.thumbnail, 'el logo del campeonato')
        }

        // Subida de la plantilla
        if (matchData.template) {
            matchData.template = await uploadMatchImage(matchData.template, 'el fondo de la entrada')
        }

        const { data, status} = await Axios.post('/api/match/register', matchData, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'MATCH_ADD_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'MATCH_ADD_SUCCESS',
            payload: {
                message: 'uploadImageError',
                details: error?.message || 'Error al subir imágenes del partido'
            }
        })
    }
}

export const editMatch = (matchId, matchData) => async (dispatch) => {
    dispatch({
        type: 'MATCH_LOADING'
    })
    try {
        // Subida de escudo del anfitrión (solo si es un archivo nuevo)
        if (matchData.hostBadge && typeof matchData.hostBadge !== 'string') {
            matchData.hostBadge = await uploadMatchImage(matchData.hostBadge, 'el escudo local')
        }

        // Subida de escudo del visitante (solo si es un archivo nuevo)
        if (matchData.visitorBadge && typeof matchData.visitorBadge !== 'string') {
            matchData.visitorBadge = await uploadMatchImage(matchData.visitorBadge, 'el escudo visitante')
        }

        // Subida de la miniatura (solo si es un archivo nuevo)
        if (matchData.thumbnail && typeof matchData.thumbnail !== 'string') {
            matchData.thumbnail = await uploadMatchImage(matchData.thumbnail, 'el logo del campeonato')
        }

        // Subida de la plantilla (solo si es un archivo nuevo)
        if (matchData.template && typeof matchData.template !== 'string') {
            matchData.template = await uploadMatchImage(matchData.template, 'el fondo de la entrada')
        }

        const { data, status} = await Axios.post('/api/match/edit/' + matchId, matchData, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'MATCH_ADD_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'MATCH_ADD_SUCCESS',
            payload: {
                message: 'uploadImageError',
                details: error?.message || 'Error al subir imágenes del partido'
            }
        })
    }
}

export const deleteMatch = (matchId) => async (dispatch) => {
    dispatch({
        type: 'MATCH_LOADING'
    })
    try {
        const { data, status } = await Axios.delete('/api/match/delete/'+ matchId, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'MATCH_EDIT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'MATCH_NOT_LOADING'
        })
    }
}

export const checkMatchExist = (selectedMatch, identifierMatch) => async (dispatch) => {
    dispatch({
        type: 'MATCH_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/match/checkmatchexist/'+ selectedMatch + '/' + identifierMatch)
        if (status === 200) {
            dispatch({
                type: 'MATCH_EXIST_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'MATCH_NOT_LOADING'
        })
    }
}

export const scanEntry = (entryCode, selectedMatch, identifierMatch) => async (dispatch) => {
    dispatch({
        type: 'MATCH_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/match/scanentry/'+ entryCode + '/' + selectedMatch + '/' + identifierMatch)
        if (status === 200) {
            dispatch({
                type: 'MATCH_GETENTRY_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'MATCH_NOT_LOADING'
        })
    }
}

export const checkInOut = (entryCode, selectedMatch, checkType) => async (dispatch) => {
    dispatch({
        type: 'MATCH_ENTRY_LOADING'
    })
    try {
        const { data, status} = await Axios.post('/api/match/checkinout/', {id: entryCode, match: selectedMatch, checkType}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'MATCH_CHECKINOUT_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'MATCH_ENTRY_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'MATCH_ENTRY_NOT_LOADING'
        })
    }
}

export const getChecksByMatch = (matchId) => async (dispatch) => {
    dispatch({
        type: 'MATCH_ENTRY_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/match/getchecksbymatch/'+ matchId, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'MATCH_CHECKS_GET_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'MATCH_ENTRY_NOT_LOADING'
        })
    }
}

export const toggleMatchActive = (matchId) => async (dispatch) => {
    dispatch({
        type: 'MATCH_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/match/toggleActive/' + matchId, {}, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'MATCH_TOGGLE_ACTIVE_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'MATCH_NOT_LOADING'
        })
    }
}

